<div class="grid-component">
  @if (props.label) {
    <label tabindex="0" [innerHTML]="props.label"></label>
  }
  <div class="toolbar clearfix w-100">
    @if (showTemplates) {
      <mat-form-field class="col-9">
        <mat-label>{{ label }}</mat-label>
        <mat-select
          [placeholder]="placeholder"
          [disabled]="(!firmTemplates && !templates) || field.form.disabled"
          (selectionChange)="applyTemplate($event)"
        >
          @if (firmTemplates && firmTemplates.length > 0) {
            <mat-optgroup label="Firm Templates">
              @for (tmplt of firmTemplates; track tmplt) {
                <mat-option [value]="tmplt">
                  {{ tmplt.name }}
                </mat-option>
              }
            </mat-optgroup>
          }
          @if (templates && templates.length > 0) {
            <mat-optgroup label="User Templates">
              @for (tmplt of templates; track tmplt) {
                <mat-option [value]="tmplt">
                  {{ tmplt.name }}
                </mat-option>
              }
            </mat-optgroup>
          }
        </mat-select>
        <mat-hint />
      </mat-form-field>
    }
    @if (fiveTwoNineSearch) {
      <mat-form-field class="col-12">
        <mat-label>Select a Plan</mat-label>
        <mat-select
          [(ngModel)]="selected529"
          (selectionChanged)="handle529($event)"
        >
          @for (plan of plans529; track plan.PlanName) {
            <mat-option [value]="plan">{{ plan.PlanName }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (canSearchInvestments && searchOptions) {
      <app-fund-search
        class="search-box mb-3"
        [type]="props.searchType"
        [options]="searchOptions"
        [program]="program"
        [fiveTwoNinePlan]="selected529?.PlanId"
        (fundSelected)="handleFund($event)"
      />
      @if (canUseFundLookupPopulateBtn) {
        <button
          mat-raised-button
          type="button"
          color="accent"
          (click)="fundLookup()"
        >
          Fund Lookup Data
        </button>
      }
      @if (buttonOption && this.field['showButton']) {
        <button
          mat-button
          class="btn btn-primary pull-right"
          color="primary"
          type="button"
          [disabled]="field.form.disabled"
          (click)="add()"
        >
          <mat-icon class="me-2">add_circle</mat-icon>{{ buttonOption }}
        </button>
      }
    }
    @if (!searchOptions && this.field['showButton'] && !hideDelete) {
      <button
        mat-button
        class="btn btn-primary pull-right"
        color="primary"
        type="button"
        (click)="add()"
      >
        <mat-icon class="me-2">add_circle</mat-icon>Add
      </button>
    }
  </div>

  @if (this.field['showCsvFunctions']) {
    <div>
      <span class="pull-right">
        <button
          mat-button
          class="btn btn-primary pull-right"
          color="primary"
          type="button"
          (click)="downloadCsvTemplate($event)"
        >
          <mat-icon>download</mat-icon>Download CSV Template
        </button>
      </span>
      <span class="pull-right">
        <input
          #csvUpload
          type="file"
          class="file-input"
          (change)="onFileSelected($event)"
        />

        <span class="file-upload">
          @if (fileName) {
            <div class="upload-file-name mb-1">
              File selected: <strong class="ms-1 me-2">{{ fileName }}</strong>
              <button
                type="button"
                class="confirm-button"
                matTooltip="Confirm upload"
                (click)="completeCsvUpload()"
              >
                <mat-icon>check</mat-icon>
              </button>
              <button
                type="button"
                class="cancel-button me-2"
                matTooltip="Choose a different file"
                for="csvUpload"
                (click)="csvUpload.click()"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>
          } @else {
            <button
              mat-button
              class="btn btn-primary pull-right"
              color="primary"
              for="csvUpload"
              type="button"
              (click)="csvUpload.click()"
            >
              <mat-icon class="me-2">upload</mat-icon>Upload CSV/Excel
            </button>
          }
        </span>
      </span>
    </div>
  }

  @if (externalButtonOption && this.field['showExternalButton']) {
    <button
      mat-button
      class="mb-2 product-shelf-btn"
      color="primary"
      type="button"
      [disabled]="field.form.disabled"
      (click)="onLinkClick()"
    >
      <mat-icon class="me-2">search</mat-icon
      >{{ this.field.fieldArray.props.externalBtnText }}
    </button>
  }

  @if (field.key === 'SelectedFunds') {
    <h5 class="w-100 pull-right">
      Investment Program: {{ investmentProgramLabel }}
    </h5>
  }

  @if (!loading && checkShowGrid()) {
    <div class="form-grid-container col-12">
      <kendo-grid
        #gridExp
        [kendoGridBinding]="model"
        [selectable]="{ enabled: false }"
        [isDetailExpanded]="expandDetailsBy"
        [navigable]="true"
        [(expandedDetailKeys)]="expandedDetailKeys"
      >
        @for (column of columns; track column) {
          @if (!hideColumn(field, column, 0)) {
            <kendo-grid-column
              [field]="column.key"
              [editable]="true"
              [hidden]="column.visuallyHidden"
            >
              <ng-template kendoGridHeaderTemplate>
                <div [ngClass]="{ 'has-help': column.help }">
                  {{ column.label }}
                  @if (column.help) {
                    <span
                      matTooltip="{{ props.help }}"
                      aria-label="help"
                      tabindex="0"
                      [matTooltipPosition]="'above'"
                      [matTooltipClass]="'rb-tooltip'"
                    >
                      <mat-icon class="col-1 help-icon"> help </mat-icon>
                    </span>
                  }
                </div>
              </ng-template>

              @if (SELL_FIELDS_MAPPING.includes(column.key)) {
                <ng-template
                  let-rowIndex="rowIndex"
                  let-value="value"
                  let-row="row"
                  kendoGridCellTemplate
                >
                  <mat-checkbox
                    [checked]="sellChecked(rowIndex, column.key)"
                    (change)="changeSell(rowIndex, field, column, rowIndex)"
                  >
                    <span>Sell</span>
                  </mat-checkbox>
                </ng-template>
              } @else {
                <ng-template
                  let-rowIndex="rowIndex"
                  let-value="value"
                  let-row="row"
                  kendoGridCellTemplate
                  k-grid-ignore-click
                >
                  <formly-field
                    k-grid-ignore-click
                    [field]="getField(field, column, rowIndex)"
                  />
                </ng-template>
              }
            </kendo-grid-column>
          }
        }
        @if (!hideDelete) {
          <kendo-grid-column width="60">
            <ng-template
              let-rowIndex="rowIndex"
              let-value="value"
              let-row="row"
              kendoGridCellTemplate
            >
              <button
                type="button"
                mat-icon-button
                class="delete"
                matToolTip="Delete Entry"
                (click)="remove(rowIndex, $event)"
              >
                <mat-icon>cancel</mat-icon>
              </button>
            </ng-template>
          </kendo-grid-column>
        }

        <ng-template
          let-rowIndex="rowIndex"
          let-value="value"
          let-row="row"
          kendoGridDetailTemplate
        >
          <section>
            @for (subField of subFields; track subField) {
              @if (
                subField.props.subField &&
                !getField(field, subField, rowIndex).hide
              ) {
                <formly-field
                  k-grid-ignore-click
                  [field]="getField(field, subField, rowIndex)"
                />
              }
            }
          </section>
        </ng-template>
        <ng-template kendoGridNoRecordsTemplate>{{ noRecords }}</ng-template>
      </kendo-grid>
    </div>
  }
</div>
<ngx-loading [show]="uploadingFile || fundLookupLoading" />
